/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { advSearchState } from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import companySearchState from 'Stores/companySearch';
import * as CONSTANTS from 'Utils/constants';

import CheckBox from 'Components/common/CheckBox';
import { Utils } from 'Utils/utils';
import noSuggestionFound from 'Assets/png/noSuggestionFound.png';
import { ToggleType } from 'Components/common/Toggle';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
// import { ReactComponent as PlusIcon } from 'Assets/svg/plus-icon.svg';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';

let renderListFun;
const InputBoxWithSuggestion = observer(props => {
  const {
    inputVal,
    placeholder,
    setInputVal,
    suggestionList,
    noMatchFound,
    setNoMatchFound,
    setSelectedItem,
    selectedItem,
    suggestionKey,
    blockedKey,
    renderList,
    filterInPage,
    currentTab = 'contact',
    submitActionAllowed = false,
    showNewFlag = false,
    callbackAction = null,
    allowExcludeFilter = false,
    isExcludeEnabled = false,
    includeExcludeToggleCbk = () => {},
    excludeToolTipInfo = '',
    includeSuggestionKey,
    excludeSuggestionKey,
  } = props;

  let currentSelectedState;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;

  const boxId = `${suggestionKey}-${currentTab}-${
    filterInPage ? 'page' : 'popup'
  }`;
  let selectedObj = [];
  let selectedGroupObj = [];
  const currentAppliedFilterData = currentSelectedState.appliedFilterData;
  if (suggestionKey === 'location') {
    selectedObj = [
      ...(currentAppliedFilterData.selectedRegions || []),
      ...(currentAppliedFilterData.selectedCountries || []),
      ...(currentAppliedFilterData.selectedStates || []),
      ...(currentAppliedFilterData.selectedCities || []),
    ];
    selectedGroupObj = selectedObj;
  } else {
    selectedObj = currentAppliedFilterData[suggestionKey] || [];
    // industry and keyword seperated
    // if (
    //   suggestionKey === 'companyKeywordV2' ||
    //   suggestionKey === 'industrySectorsV2'
    // )
    //   selectedGroupObj = [
    //     ...(currentAppliedFilterData.companyKeywordV2 || []),
    //     ...(currentAppliedFilterData.industrySectorsV2 || []),
    //   ];
    // else if (
    //   suggestionKey === 'excludeCompanyKeywordV2' ||
    //   suggestionKey === 'excludeIndustrySectorsV2'
    // )
    //   selectedGroupObj = [
    //     ...(currentAppliedFilterData.excludeCompanyKeywordV2 || []),
    //     ...(currentAppliedFilterData.excludeIndustrySectorsV2 || []),
    //   ];
  }

  const [showSuggestion, setShowSuggestion] = React.useState(false);

  const onInputChange = e => {
    if (!showSuggestion) setShowSuggestion(true);

    const inpVal = e.currentTarget.value;
    const selector = `.suggestion-list.${boxId} .suggestion-list-wrap`;
    if (document.querySelectorAll(selector).length)
      document.querySelectorAll(selector)[0].scrollTo(0, 0);

    setInputVal(inpVal);
  };

  const submitAction = e => {
    if (submitActionAllowed && e && e.charCode === 13) {
      const inpVal = e.currentTarget.value;
      const arrObj = selectedObj;
      const inpObj = { name: inpVal, pName: inpVal };
      arrObj.push(inpObj);
      if (suggestionKey === 'companyKeyword') {
        currentSelectedState.setAppliedFilters(
          suggestionKey,
          arrObj,
          null,
          true,
        );

        const mxDataMap = {};
        if (currentTab === 'contact')
          if (filterInPage) mxDataMap.filterPlace = 'page';
          else mxDataMap.filterPlace = 'popup';
        else mxDataMap.filterPlace = 'page';

        mxDataMap.currentTab = currentTab;

        switch (suggestionKey) {
          case 'companyKeyword':
            mxDataMap.companyKeywordSearch = inpVal;
            Utils.mixpanelTrack(
              CONSTANTS.MX_AS_EVENTS.AS_COMPANY_KEYWORD_SEARCH_PERFORMED,
              mxDataMap,
            );
            break;
          default:
            Utils.mixpanelTrack('AS Common Search Performed', mxDataMap);
            break;
        }
      }
      setInputVal('');
    }
  };
  const onInputFocus = e => {
    if (document !== undefined)
      document
        .getElementsByClassName('left-section')[0]
        .classList.add('stop-scroll');
  };
  const addSelectedItem = e => {
    let arrStr = selectedItem;
    let arrObj = selectedObj;

    const selectedElement = e.currentTarget.getAttribute('data-pName');
    const index = e.currentTarget.getAttribute('data-index');
    let isApplyingFilter = false;

    if (!e.currentTarget.classList.contains('selected')) {
      e.currentTarget.classList.add('selected');
      arrStr.push(selectedElement);
      if (
        typeof suggestionList[index].pName === 'string' ||
        typeof suggestionList[index].pName === 'number'
      ) {
        if (selectedElement === suggestionList[index].pName) {
          arrObj.push(suggestionList[index]);
          isApplyingFilter = true;
        }
      } else if (typeof suggestionList[index].pName === 'object') {
        if (suggestionList[index].pName.includes(selectedElement)) {
          arrObj.push(suggestionList[index]);
          isApplyingFilter = true;
        }
      }
    } else {
      arrStr = arrStr.filter(item => {
        return item !== selectedElement;
      });
      arrObj = arrObj.filter(item => {
        return item.pName !== selectedElement;
      });
      e.currentTarget.classList.remove('selected');
    }
    setSelectedItem(arrStr);

    if (isApplyingFilter) {
      const mxDataMap = {};
      if (currentTab === 'contact')
        if (filterInPage) mxDataMap.filterPlace = 'page';
        else mxDataMap.filterPlace = 'popup';
      else mxDataMap.filterPlace = 'page';

      const { isFreeTrial } = userDetail;

      mxDataMap.currentTab = currentTab;
      mxDataMap.filterKey = suggestionKey;
      mxDataMap.isFreeTrial = isFreeTrial;
      mxDataMap.searchValue = selectedElement;

      switch (suggestionKey) {
        case 'selectedCities':
          mxDataMap.citySearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_CITY_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'selectedCountries':
          mxDataMap.countrySearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_COUNTRY_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'companyName':
          mxDataMap.companySearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_COMPANY_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'selectedExcldedCountriesWholeData':
          mxDataMap.excludeCountrySearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_EXCLUDE_COUNTRY_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'keyword':
          mxDataMap.keywordText = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_INDUSTRY_KEYWORD_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;

        case 'selectedStates':
          mxDataMap.stateSearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_STATE_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'companyKeywordV2':
        case 'excludeCompanyKeywordV2':
          mxDataMap.isIncluded = true;
          if (suggestionKey === 'excludeCompanyKeywordV2')
            mxDataMap.isIncluded = false;
          mxDataMap.companyKeywordSearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.AS_COMPANY_KEYWORD_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;
        case 'location':
          // eslint-disable-next-line no-case-declarations
          const locationVal = arrObj.map(item => item.name);
          mxDataMap.searchValue = locationVal;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.LB_AS_LOCATION_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;

        case 'technologies':
          mxDataMap.technologiesSearch = selectedElement;
          Utils.mixpanelTrack(
            CONSTANTS.MX_AS_EVENTS.LB_AS_TECHNOLOGY_SEARCH_PERFORMED,
            mxDataMap,
          );
          break;

        default:
          Utils.mixpanelTrack('AS Common Search Performed', mxDataMap);
          break;
      }
    }

    if (suggestionKey === 'location') {
      const city = [];
      const state = [];
      const country = [];
      const region = [];
      arrObj.map(item => {
        if (item && item.group !== undefined) {
          if (item.group === 'city') city.push(item);
          if (item.group === 'state') state.push(item);
          if (item.group === 'country') country.push(item);
          if (item.group === 'region') region.push(item);
        }
        return null;
      });
      currentSelectedState.setAppliedFilters(
        'selectedCities',
        city,
        null,
        true,
        false,
      );
      currentSelectedState.setAppliedFilters(
        'selectedStates',
        state,
        null,
        true,
        false,
      );
      currentSelectedState.setAppliedFilters(
        'selectedCountries',
        country,
        null,
        true,
      );
      currentSelectedState.setAppliedFilters(
        'selectedRegions',
        region,
        null,
        true,
      );
    } else if (callbackAction === null) {
      currentSelectedState.setAppliedFilters(suggestionKey, arrObj, null, true);
    } else {
      callbackAction(suggestionKey, arrObj);
    }

    document.getElementById(boxId).focus();
  };
  const clearInputBox = e => {
    if (document !== undefined)
      document
        .getElementsByClassName('left-section')[0]
        .classList.remove('stop-scroll');
    setNoMatchFound(false);
    e.currentTarget.parentElement.getElementsByTagName('input')[0].focus();
    setInputVal('');
  };
  const closeSuggestion = () => {
    setInputVal('');
    if (document !== undefined)
      document
        .getElementsByClassName('left-section')[0]
        .classList.remove('stop-scroll');
    setNoMatchFound(false);
    setShowSuggestion(false);
  };
  renderListFun =
    renderList !== undefined
      ? renderList
      : () => {
          const currentAppliedFilterPostData =
            currentSelectedState.appliedFilterPostData;
          return suggestionList.map((item, index) => {
            const isIncluded =
              currentAppliedFilterPostData[includeSuggestionKey] &&
              currentAppliedFilterPostData[includeSuggestionKey].includes(
                item.pName,
              );
            const isExcluded =
              currentAppliedFilterPostData[excludeSuggestionKey] &&
              currentAppliedFilterPostData[excludeSuggestionKey].includes(
                item.pName,
              );
            const isValueSelected = allowExcludeFilter
              ? isIncluded
              : currentAppliedFilterPostData[suggestionKey] &&
                currentAppliedFilterPostData[suggestionKey].includes(
                  item.pName,
                );

            let isSelected = `${
              currentAppliedFilterPostData[suggestionKey] &&
              currentAppliedFilterPostData[suggestionKey].includes(item.pName)
                ? 'selected'
                : ''
            }`;
            let classNameVal = `suggestion-item ${isSelected}`;
            let sugKey = suggestionKey + index;

            if (suggestionKey === 'location') {
              let isMatchFind = false;
              sugKey = suggestionKey + item.id;
              const locationKeys = [
                'selectedCities',
                'selectedStates',
                'selectedCountries',
                'selectedRegions',
              ];
              locationKeys.map(locationKey => {
                if (
                  currentAppliedFilterPostData[locationKey] &&
                  currentAppliedFilterPostData[locationKey].length > 0
                )
                  currentAppliedFilterPostData[locationKey].map(posItem => {
                    if (posItem.id === item.id) isMatchFind = true;

                    return true;
                  });

                return null;
              });

              if (isMatchFind) {
                classNameVal = 'suggestion-item selected';
                isSelected = 'selected';
              }
            }
            if (
              suggestionKey === 'selectedCities' ||
              suggestionKey === 'selectedStates' ||
              suggestionKey === 'selectedCountries' ||
              suggestionKey === 'selectedRegions' ||
              suggestionKey === 'selectedExcldedCountriesWholeData'
            ) {
              // console.log('item', item);
              let isMatchFind = false;
              sugKey = suggestionKey + item.id;
              if (
                currentAppliedFilterPostData[suggestionKey] &&
                currentAppliedFilterPostData[suggestionKey].length > 0
              )
                currentAppliedFilterPostData[suggestionKey].map(posItem => {
                  if (posItem.id === item.id) isMatchFind = true;

                  return true;
                });

              if (isMatchFind) {
                classNameVal = 'suggestion-item selected';
                isSelected = 'selected';
              }
              // console.log('classNameVal ', classNameVal);
            }

            if (
              suggestionKey === 'industrySectorsV2' ||
              suggestionKey === 'excludeIndustrySectorsV2'
            ) {
              let isMatchFind = false;

              const industryAppliedFilterPostData =
                currentAppliedFilterPostData[suggestionKey] || [];
              sugKey =
                suggestionKey + item.industryOrSectorText + item.parentIndustry;
              if (industryAppliedFilterPostData.length > 0)
                industryAppliedFilterPostData.map(posItem => {
                  if (
                    posItem.industryOrSectorText ===
                      item.industryOrSectorText &&
                    posItem.parentIndustry === item.parentIndustry
                  )
                    isMatchFind = true;

                  return true;
                });

              if (isMatchFind) {
                classNameVal = 'suggestion-item selected';
                isSelected = 'selected';
              }
            }

            return (
              <div
                key={sugKey}
                className={classNameVal}
                data-name={item.name}
                data-pname={item.pName}
                data-index={index}
                onClick={addSelectedItem}
              >
                {allowExcludeFilter && isExcluded ? (
                  <span className="material-icons exclude-icon">
                    indeterminate_check_box
                  </span>
                ) : (
                  <div className="check-box">
                    <CheckBox
                      dymamicClass={
                        isValueSelected || isSelected ? 'selected' : ''
                      }
                    />
                  </div>
                )}
                <span className={suggestionKey}>
                  {suggestionKey === 'companyName' ? (
                    <>
                      <span className="name show-elipsis" title={item.orgName}>
                        {item.orgName}
                      </span>
                      <span className="domain show-elipsis" title={item.name}>
                        {item.name}
                      </span>
                    </>
                  ) : (
                    item.name
                  )}
                </span>
              </div>
            );
          });
        };

  const clearUpgradePopup = onMouseEnter => {
    if (onMouseEnter)
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_VIEWED, {
        type: `Search Filters - ${blockedKey}`,
      });
    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    const maskEle = document.getElementsByClassName('upgradePopupMask');
    if (filterInPage) maskEle[0].classList.remove('showMask');
    else maskEle[1].classList.remove('showMask');
  };

  const showUpgradePopup = event => {
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_CLICKED, {
      type: `Search Filters - ${blockedKey}`,
    });
    clearUpgradePopup();
    console.log('event.  ', event.currentTarget);
    if (event !== undefined)
      event.currentTarget.classList.add('show-upgrade-popup');

    const maskEle = document.getElementsByClassName('upgradePopupMask');
    if (filterInPage) maskEle[0].classList.add('showMask');
    else maskEle[1].classList.add('showMask');
  };

  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    Utils.upgradeNowClick('filters');
  };

  const onPlusClick = (e, key) => {
    document.getElementById(key).focus();
  };

  const NoMatchFoundComponent = () => {
    return (
      <div className="no-match-found">
        <img src={noSuggestionFound} alt="No suggestion found" />
        No results found
      </div>
    );
  };

  return (
    <>
      <div
        className={`input-section ${showSuggestion ? 'input-focused' : ''}${
          filterInPage ? ' page-suggestion' : ' popup-suggestion'
        } ${
          allowExcludeFilter ? ' no-bottom-space' : ''
        } ${suggestionKey}-filter`}
      >
        <span>
          <input
            className="input-box"
            value={inputVal}
            type="text"
            placeholder={placeholder}
            onChange={onInputChange}
            onFocus={onInputFocus}
            id={boxId}
            onKeyPress={submitAction}
            autoComplete="new-password"
            // onBlur={closeSuggestion}
          />
          <span className="ripple-effect" />
          <span className="focus-border" />
          {selectedGroupObj.length > 0 || selectedObj.length > 0 ? (
            <div className="dropdown-icon selected-count">
              <span>
                {selectedGroupObj.length > 0
                  ? selectedGroupObj.length
                  : selectedObj.length}
              </span>
            </div>
          ) : (
            !showSuggestion && (
              <SearchIcon
                className="dropdown-icon plus-icon"
                width={14}
                height={14}
                onClick={e => onPlusClick(e, boxId)}
              />
            )
          )}
          {showNewFlag && !showSuggestion && (
            <span className="new-feature-text">new</span>
          )}
        </span>
        <div
          className={`suggestion-list ${boxId} animatedFast ${
            showSuggestion ? '' : 'hide-suggestion'
          } ${
            suggestionList.length > 0 || noMatchFound ? 'box-design-shadow' : ''
          }`}
        >
          {(suggestionList.length > 0 || noMatchFound) && (
            <>
              {noMatchFound ? (
                <div className="suggestion-list-wrap">
                  <NoMatchFoundComponent />
                </div>
              ) : (
                <div className="suggestion-list-wrap">{renderListFun()}</div>
              )}
            </>
          )}
        </div>
        {showSuggestion &&
          (suggestionList.length > 0 || noMatchFound || inputVal === '') && (
            <div className="suggestion-mask" onClick={closeSuggestion} />
          )}
      </div>

      {allowExcludeFilter ? (
        <div className="include-exclude-toggle icon-text-wrapper">
          <ToggleType
            firstText="Include"
            toggle={isExcludeEnabled}
            offer={false}
            cbk={includeExcludeToggleCbk}
            lastText="Exclude"
            showSharpPoint
          />
          <div className="icon-container">
            <InfoIcon width={18} height={18} className="title-info-icon" />
            <div className="tooltip-wrap">
              <span className="tooltip">{excludeToolTipInfo}</span>
              <span className="sharp-point" />
            </div>
          </div>
          <span className="ripple-effect" />
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export { InputBoxWithSuggestion };
export default InputBoxWithSuggestion;
